import { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

const ProductDetailsHeaderSmallContainer = (props: Props) => {
  const { children } = props;

  return <View style={styles.container}>{children}</View>;
};

const ProductDetailsHeaderSmallContentContainer = (props: Props) => {
  const { children } = props;

  return <View style={styles.contentContainer}>{children}</View>;
};

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsHeaderSmall = {
  Container: ProductDetailsHeaderSmallContainer,
  ContentContainer: ProductDetailsHeaderSmallContentContainer,
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['1'],
  },
  contentContainer: {
    flex: 1,
    paddingTop: theme.spacing['5'],
    gap: theme.spacing['6'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
